import React, { useState, useEffect, useRef } from 'react';
import AboutImage from '../../../assests/images/aboutus.jpeg'
import SectionImage from '../../../assests/about.png'
import Abouts from '../../mainSection/aboutPage/about';
import Culturet_count from '../../../assests/images/culture-count.png'
import mabout from '../../../assests/mabout.png'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet } from "react-helmet";

const About = () => {
    const sectionRef = useRef(null);
    const [bgPositionYx, setBgPositionYx] = useState(2.45);
    useEffect(() => {
        AOS.init({
            duration: 1000, // animation duration
            once: true, // whether animation should happen only once
        });
    }, []);
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                const { isIntersecting, boundingClientRect } = entry;
                const isEnteringFromBottom = isIntersecting && boundingClientRect.top > 0;

                setIsVisible(isEnteringFromBottom);
            },
            { threshold: 0.1 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    // useEffect(() => {
    //     const handleScroll = () => {
    //         const scrollY = window.scrollY;
    //         const newPositionYx = 2.69531 - scrollY * 2; // Adjust the multiplier as needed
    //         setBgPositionYx(newPositionYx);
    //     };

    //     window.addEventListener('scroll', handleScroll);
    //     return () => window.removeEventListener('scroll', handleScroll);
    // }, []);
    return (
        <div className="font-recoleta z-1">
            <Helmet>
                <title>Top #1  IT Solutions Company | IT Staffing Services - TekIT</title>
                <meta name="description" content="Accelerate your business growth with our IT services. From software development to digital solutions, we deliver customized, reliable, and on-time results." />
                <meta name="keywords" content="Top IT Staff Augmentation Companies, IT Staffing Services, Largest IT Staffing Companies, Staffing IT, Contract IT Staffing, Staffing IT Services, IT Staffing, Staffing Solutions, IT Staffing Solutions, Premier Staffing Solutions, IT Services, Executive Staffing, Staffing Company, staffing services" />
            </Helmet>
            <section
                className="parallax wow fadeIn hidden lg:block animated relative transition-opacity duration-700 h-[650px]"
                data-stellar-background-ratio="0.5"
                style={{
                    backgroundImage: `url(${SectionImage})`,
                    backgroundPosition: `0px ${bgPositionYx}px`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    position: "inherit",
                    visibility: "visible",
                }}
            >
                {/* <div className="absolute inset-0 bg-[#1c1c1c]/80 z-0" /> */}

                <div className="container mx-auto relative z-1 py-24 mt-[-2px]">
                    <div className="flex justify-center mt-28">
                        <div className="w-full  text-center">
                            <div className="relative overflow-hidden w-full">
                                <span className="text-white 2xl:text-[48px] lg:text-[39px] text-[64px] tracking-widest font-semibold uppercase" >
                                    Our values & commitments
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-wrap justify-center gap-y-10">
                        {[
                            { letter: "T", label: "Talent", delay: "0s" },
                            { letter: "E", label: "Empathy", delay: "0.2s" },
                            { letter: "K", label: "K-reativity", delay: "0.4s" },
                            { letter: "I", label: "Intelligence", delay: "0.6s" },
                            { letter: "T", label: "Team Work", delay: "0.8s" },
                        ].map((item, index) => (
                            <div
                                key={index}
                                className="w-1/2 md:w-1/3 lg:w-1/6 text-center animate-fadeInDown"
                                style={{ animationDelay: item.delay }}
                            >
                                <h4 className="text-white font-light lg:text-[40px] text-[80px] m-0">{item.letter}</h4>
                                <span className="text-white block my-2 2xl:text-[20px] lg:text-[16px] text-[44px]">{item.label}</span>
                                <div className="h-[20px] w-[1px] lg:text-[14px]  bg-[#f5f5f8] mx-auto"></div>
                            </div>
                        ))}
                    </div>

                    <div className="text-white text-center mt-16 text-[24px] 2xl:text-[20px] lg:text-[16px]">
                        We vibe with quality and stick to deadlines
                    </div>
                </div>
            </section>

            <section
                className="lg:hidden block relative w-full bg-black  bottom-40 h-full bg-contain bg-no-repeat"
                data-stellar-background-ratio="0.5"
                style={{
                    backgroundImage: `url(${mabout})`,
                    visibility: "visible",
                }}
            >
                {/* Dark Overlay */}
                {/* <div className="absolute inset-0 bg-black opacity-60 z-0" /> */}

                <div className="container mx-auto top-60 relative z-1 ">
                    <div className=" justify-self-center  ">
                        <div className=" text-center ">
                            <div className="relative top-8 overflow-hidden mt-28  pt-10">
                            <span className="text-white lg:text-[16px] text-[64px] tracking-widest font-semibold uppercase  leading-[55px]" >
                            Our values & commitments
                        </span>
                            </div>
                        </div>
                    </div>
                    <div className=" justify-self-center gap-y-10 mt-[60px]">
                        {[
                            { letter: "T", label: "Talent", delay: "0s" },
                            { letter: "E", label: "Empathy", delay: "0.2s" },
                            { letter: "K", label: "K-reativity", delay: "0.4s" },
                            { letter: "I", label: "Intelligence", delay: "0.6s" },
                            { letter: "T", label: "Team Work", delay: "0.8s" },
                        ].map((item, index) => (
                            <div
                                key={index}
                                className="w-full text-center animate-fadeInDown"
                            // style={{ animationDelay: item.delay }}
                            >

                                <h4 className="text-white lg:text-[40px] text-center text-[100px] font-bold m-0">{item.letter}</h4>
                                <span className="text-white justify-self-center block my-2 lg:text-[14px] text-[54px]">{item.label}</span>
                                <div className="h-[40px] w-[3px] lg:text-[14px]  bg-[#2B30C0] mx-auto"></div>
                            </div>
                        ))}
                    </div>

                    <div className="text-white text-center mt-16 text-[32px] pb-96">
                        We vibe with quality and stick to deadlines
                    </div>
                </div>
            </section>
            {/* <div className='max-w-8xl mx-auto lg:w-[84%]  xxl:w-[80%] lg:px-4 px-8 py-8 lg:block hidden'>
                <h1 className='font-recoleta 2xl:text-[40px] lg:text-[32px] text-[34px] font-normal mb-8 text-center text-[#09588D]' style={{ fontWeight: '700' }} data-aos="fade-up" >
                    A Trusted Leader in IT Solutions and Services Since Inception
                </h1>

                <div className='lg:flex flex-col lg:flex-row gap-8 items-center'>
                    <div className='w-full lg:w-1/2'>
                        <img src={SectionImage} alt="banner" className="w-full h-auto rounded" data-aos="fade-right" />
                    </div>
                    <div className='w-full lg:w-1/2 lg:mt-0 mt-8'>
                        <h2 className='font-semibold mb-4 text-[#09588D] font-recoleta text-[54px] 2xl:text-[26px] lg:text-[22px]' data-aos="fade-left">
                            FTransforming Ideas into Impact with Distinctive Tech & Talent Solutions 

                        </h2>
                        <p className='mb-4 2xl:text-[20px] lg:text-[16px] text-[36px] font-recoleta text-gray-700' data-aos="fade-left">
                            Headquartered in the USA, with development centres located in the heart of India, Indore. TekIT is a customer-oriented full-service IT firm that has been serving hundreds of clients and helping them grow since its inception. With several years of experience in custom software development, we have successfully designed innovative solutions and provided outsourcing solutions that were profit-driven and highly scalable.
                        </p>
                        <p className='text-gray-700 2xl:text-[20px] lg:text-[16px] text-[36px]' data-aos="fade-left">
                            Our clients’ needs and demands are what we value the most that have helped us build tremendous relationships with them. We don’t just create software, we focus on the entire experience that comes with it that helps clients acquire millions of customers in the long run.
                        </p>
                    </div>
                </div>
            </div> */}

            {/* <div className='w-[84%] py-8 block lg:hidden justify-self-center'>
                <h1 className='font-recoleta 2xl:text-[40px] lg:text-[32px] text-[34px] font-normal mb-8 text-center text-[#09588D]' style={{ fontWeight: '700' }} data-aos="fade-up" >
                    A Trusted Leader in IT Solutions and Services Since Inception
                </h1>

                <div className='lg:flex flex-col lg:flex-row gap-8 items-center'>
                    <div className='w-full lg:w-1/2'>
                        <img src={SectionImage} alt="banner" className="w-full h-auto rounded" data-aos="fade-right" />
                    </div>
                    <div className='w-full lg:w-1/2 lg:mt-0 mt-8'>
                        <h2 className='font-semibold mb-4 text-[#09588D] font-recoleta text-[54px] 2xl:text-[26px] lg:text-[20px]' data-aos="fade-left">
                            FTransforming Ideas into Impact with Distinctive Tech & Talent Solutions 

                        </h2>
                        <p className='mb-4 2xl:text-[20px] lg:text-[16px] text-[36px] font-recoleta text-gray-700' data-aos="fade-left">
                            Headquartered in the USA, with development centres located in the heart of India, Indore. TekIT is a customer-oriented full-service IT firm that has been serving hundreds of clients and helping them grow since its inception. With several years of experience in custom software development, we have successfully designed innovative solutions and provided outsourcing solutions that were profit-driven and highly scalable.
                        </p>
                        <p className='text-gray-700 2xl:text-[20px] lg:text-[16px] text-[36px]' data-aos="fade-left">
                            Our clients’ needs and demands are what we value the most that have helped us build tremendous relationships with them. We don’t just create software, we focus on the entire experience that comes with it that helps clients acquire millions of customers in the long run.
                        </p>
                    </div>
                </div>
            </div> */}

            {/* <div className='bg-gradient-to-r from-[#0aace7] to-[#8fe1ff] py-20'>
                <h1 className='text-[#09588D] text-center px-8 lg:px-0 text-[40px] 2xl:text-[40px] lg:text-[32px]' style={{ fontWeight: '700' }} data-aos="fade-up">At TekIT we not only develop, we Innovate!</h1>
            </div> */}
            <Abouts />
        </div>
    );
};

export default About;